var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.95C0 1.43283 0.205446 0.936838 0.571142 0.571142C0.936838 0.205446 1.43283 0 1.95 0H11.05C11.5672 0 12.0632 0.205446 12.4289 0.571142C12.7946 0.936838 13 1.43283 13 1.95V7.15C13 7.66717 12.7946 8.16316 12.4289 8.52886C12.0632 8.89456 11.5672 9.1 11.05 9.1H1.95C1.43283 9.1 0.936838 8.89456 0.571142 8.52886C0.205446 8.16316 0 7.66717 0 7.15V1.95ZM5.85 4.55C5.85 4.37761 5.91848 4.21228 6.04038 4.09038C6.16228 3.96848 6.32761 3.9 6.5 3.9C6.67239 3.9 6.83772 3.96848 6.95962 4.09038C7.08152 4.21228 7.15 4.37761 7.15 4.55C7.15 4.72239 7.08152 4.88772 6.95962 5.00962C6.83772 5.13152 6.67239 5.2 6.5 5.2C6.32761 5.2 6.16228 5.13152 6.04038 5.00962C5.91848 4.88772 5.85 4.72239 5.85 4.55ZM6.5 2.6C5.98283 2.6 5.48684 2.80545 5.12114 3.17114C4.75545 3.53684 4.55 4.03283 4.55 4.55C4.55 5.06717 4.75545 5.56316 5.12114 5.92886C5.48684 6.29455 5.98283 6.5 6.5 6.5C7.01717 6.5 7.51316 6.29455 7.87886 5.92886C8.24455 5.56316 8.45 5.06717 8.45 4.55C8.45 4.03283 8.24455 3.53684 7.87886 3.17114C7.51316 2.80545 7.01717 2.6 6.5 2.6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon-13.a26ee529fa741ab45df2d3f1183bb0a9.svg";
export { ForwardRef as ReactComponent };